const domainErrorTag = Symbol('domainErrorTag')
export class DomainError extends Error {
  [domainErrorTag] = true
  name = 'DomainError'
}
